import { render, staticRenderFns } from "./TableCols.vue?vue&type=template&id=0b232ba1"
import script from "./TableCols.vue?vue&type=script&lang=js"
export * from "./TableCols.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports